import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { initialPrognosis } from "@app/dp-shared";
import { _className, Grid, LL_V_L, TS_PropRenderer } from "@nu-art/thunderstorm-frontend";
import './Editor_DiseaseProfile_Prognosis.scss';
import { FadeScrollWrapper, ICONS } from "@app/styles";
import { DefaultEditor_TextArea } from "@app/styles/frontend/ui-manager/ui-components";
import { cloneObj } from "@nu-art/ts-common";
import { Component_PrognosisItemEditor } from "../../../../../../components/Component_PrognosisEditor/Component_PrognosisItemEditor.js";
const Field_PrognosisNotes = (props) => {
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Notes', children: _jsx(DefaultEditor_TextArea, { editable: props.editable, prop: 'prognosisNotes', disabled: !props.editMode }) });
};
const Field_Prognosis = (props) => {
    const editable = props.editable.editProp('prognosis', []);
    const addPrognosis = () => {
        const newEpidemiology = cloneObj(initialPrognosis);
        editable.updateArrayAt(newEpidemiology);
    };
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Prognosis', children: _jsxs(LL_V_L, { className: 'e__disease-profile__prognosis-items', children: [editable.item.map((ref, index) => {
                    const editableEpidemiology = editable.editProp(index, {});
                    editableEpidemiology.setOnDelete(async () => editable.removeArrayItem(index));
                    return _jsx(Component_PrognosisItemEditor, { editable: editableEpidemiology, editMode: props.editMode, withRemoveIcon: true }, index);
                }), props.editMode && _jsx(ICONS.advisor_avn_add.component, { onClick: addPrognosis })] }) });
};
export const Editor_DiseaseProfile_Prognosis = (props) => {
    const className = _className('e__disease-profile__prognosis', props.editMode && 'edit-mode');
    return _jsx(FadeScrollWrapper, { className: className, children: _jsxs(Grid, { children: [_jsx(Field_PrognosisNotes, { ...props }), _jsx(Field_Prognosis, { ...props })] }) });
};
//# sourceMappingURL=Editor_DiseaseProfile_Prognosis.js.map